import React from "react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { contact, steps } from "../mock";
import { MessageCircle } from "lucide-react";
import CmsContent from "../components/CmsContent";

const betSteps = [
  { title: "Log in to your account", desc: "Use the online cricket id and password shared by our team on WhatsApp to log in to your chosen platform." },
  { title: "Go to the betting section", desc: "On the intuitive dashboard, open the betting section to see ongoing matches, upcoming fixtures and casino games." },
  { title: "Select match or casino game", desc: "Choose the cricket match or live casino game displayed on screen that you wish to participate in." },
  { title: "Place your bet", desc: "Pick from the available options — winning team, player runs, and more — selecting one option at a time." },
  { title: "Enter amount & confirm", desc: "Enter your stake, then tap confirm. Your bet is placed — now enjoy the game and track it live." },
];

const HowToPlay = () => {
  return (
    <main>
      <PageHero
        crumb="How to Play"
        title="How to"
        highlight="Play"
        subtitle="From getting your online cricket id to placing your first bet — here is the complete, beginner-friendly guide."
      />

      <section className="py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading eyebrow="Step 1" title="Get Your" highlight="Cricket ID" center={false} />
          <div className="space-y-4">
            {steps.map((s, i) => (
              <Reveal key={s.step} delay={i * 70}>
                <div className="flex items-start gap-5 card-neon rounded-2xl p-5">
                  <div className="h-11 w-11 shrink-0 grid place-items-center rounded-full bg-[#00ff87] text-black font-display font-bold">{i + 1}</div>
                  <div>
                    <h3 className="font-display font-semibold text-lg text-white">{s.title}</h3>
                    <p className="text-gray-400 text-sm mt-1">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-[#08080f]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading eyebrow="Step 2" title="How to Place" highlight="Your Bets" center={false} />
          <div className="relative pl-8">
            <div className="absolute left-3 top-2 bottom-2 w-px bg-gradient-to-b from-[#00ff87] to-[#00e5ff]" />
            {betSteps.map((s, i) => (
              <Reveal key={s.title} delay={i * 70}>
                <div className="relative mb-8">
                  <div className="absolute -left-[22px] top-1 h-4 w-4 rounded-full bg-[#00ff87] border-4 border-[#08080f]" />
                  <h3 className="font-display font-semibold text-lg text-white">{s.title}</h3>
                  <p className="text-gray-400 text-sm mt-1">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="text-center mt-6">
            <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="btn-neon inline-flex items-center gap-2 px-8 py-3.5 rounded-xl font-display font-semibold">
              <MessageCircle size={20} /> Get Started on WhatsApp
            </a>
          </div>
        </div>
      </section>
      <CmsContent slug="how-to-play" fallbackTitle="How to Play | DaddyAnna Cricket ID" />
    </main>
  );
};

export default HowToPlay;
